export class CalculatorComponent {
    private static instance: CalculatorComponent;
    private principal: number = 0;
    private readonly interestRate: number = 0;
    private numPayments: number = 0;
    private monthlyPayment: number = 0;
    private purchaseValReady: boolean = true;
    private numPaymentsReady: boolean = true;
    private readonly PurchaseValueLiteral = "edit-purchase-value";
    private readonly NumPaymentsLiteral = "edit-payments-value";
    private readonly PurchaseTooltip = ".edit-purchase-title-wrapper .new-calculator-tooltip";
    private readonly NumPaymentsTooltip = ".edit-payments .new-calculator-tooltip";

    static getInstance(): CalculatorComponent {
        if (!CalculatorComponent.instance) {
            CalculatorComponent.instance = new CalculatorComponent();
        }
        return CalculatorComponent.instance;
    }
    constructor() {
        this.initPurchaseTitle();
        this.initNumPayments();
        const interestRateInput = document.getElementById("interest-value") as HTMLInputElement;
        this.interestRate = Number(interestRateInput?.value) || 3.2; // Default interest rate
        const purchaseValueInput = document.getElementById(this.PurchaseValueLiteral) as HTMLInputElement;
        this.principal = Number(purchaseValueInput?.value) || 100;  // Default purchase value
        const numOfPaymentsInput = document.getElementById(this.NumPaymentsLiteral) as HTMLInputElement;
        this.numPayments = Number(numOfPaymentsInput?.value) || 5; // Default number of payments
        console.log("CalculatorComponent initialized");
    }

    initPurchaseTitle(): void {
        const purchaseValueDiv = document.querySelector(".edit-purchase-title-wrapper .input-div") as HTMLInputElement;
        const purchaseValueInput = document.getElementById(this.PurchaseValueLiteral) as HTMLInputElement;
        
        let self= this;
        if(purchaseValueDiv){
            purchaseValueDiv.addEventListener('click', () => {
                if (purchaseValueInput) purchaseValueInput.focus();
            });
        }
        if (purchaseValueInput) {
            const min = Number(purchaseValueInput.min) || 100;
            const max = Number(purchaseValueInput.max) || 10000;
            purchaseValueInput.addEventListener('input', function (event) {
                purchaseValueInput.value = purchaseValueInput.value.replace(/\D/g, '');
                const newValue = Number(purchaseValueInput.value);
                if (newValue < min || newValue > max) {
                    self.showErrorTooltip(self.PurchaseTooltip);
                    self.purchaseValReady = false;
                } else {
                    self.hideErrorTooltip(self.PurchaseTooltip);
                    self.principal = newValue;
                    self.purchaseValReady = true;
                }
            });
            purchaseValueInput.addEventListener('change', function (event) {
                self.handleCalculation();
            });
        }
    }

    initNumPayments(): void {
        const numOfPaymentsDiv = document.querySelector(".edit-payments .input-div") as HTMLInputElement;
        const numOfPaymentsInput = document.getElementById(this.NumPaymentsLiteral) as HTMLInputElement;

        let self= this;
        if(numOfPaymentsDiv){
            numOfPaymentsDiv.addEventListener('click', () => {
                if (numOfPaymentsInput) numOfPaymentsInput.focus();
            });
        }
        if (numOfPaymentsInput) {
            const min = Number(numOfPaymentsInput.min) || 5;
            const max = Number(numOfPaymentsInput.max) || 10;
            numOfPaymentsInput.addEventListener('input', function (event) {
                numOfPaymentsInput.value = numOfPaymentsInput.value.replace(/\D/g, '');
                const newValue = Number(numOfPaymentsInput.value);
                if (newValue < min || newValue > max) {
                    self.showErrorTooltip(self.NumPaymentsTooltip);
                    self.numPaymentsReady = false;
                } else {
                    self.hideErrorTooltip(self.NumPaymentsTooltip);
                    self.numPayments = newValue;
                    self.numPaymentsReady = true;
                }
            });
            numOfPaymentsInput.addEventListener('change', function (event) {
                self.handleCalculation();
            });
        }
    }

    showErrorTooltip(selector: string): void {
        if (!selector) return;
        const errorToolip = document.querySelector(selector) as HTMLElement;
        if (errorToolip) {
            errorToolip.style.display = 'block';
        }
    }

    hideErrorTooltip(selector: string): void {
        if (!selector) return;
        const errorToolip = document.querySelector(selector) as HTMLElement;
        if (errorToolip) {
            errorToolip.style.display = 'none';
        }
    }
    
    handleCalculation(): void {
        if (!this.numPaymentsReady || !this.purchaseValReady) {
            console.log("Calculator is not ready for calculation.");
            return;
        }
        const outputDiv = document.getElementById("monthly-payments-value") as HTMLInputElement;
        if (!outputDiv) {
            console.log("Output element not found");
            return;
        }
        // M = P [ r(1 + r)^n ] / [ (1 + r)^n – 1]
        const P = this.principal;
        const annualRate = this.interestRate / 100;
        const n = this.numPayments;
        const r = annualRate / 12;
        if (r === 0) {
            this.monthlyPayment = Number((P / n).toFixed(2));
        } else {
            const numerator = r * Math.pow(1 + r, n);
            const denominator = Math.pow(1 + r, n) - 1;
            this.monthlyPayment = Number((P * numerator / denominator).toFixed(2));
        }
        outputDiv.value = String(this.monthlyPayment);
    }
}

(async () => {
    document.addEventListener('DOMContentLoaded', async () => {
        const sectionDOM = document.querySelector(".new-calculator-section") as HTMLElement;
        const wrapperDOM = document.querySelector(".new-calculator-wrapper") as HTMLElement;
        if(sectionDOM || wrapperDOM){
            CalculatorComponent.getInstance();
        }
        
    });
})();